<template>
  <div class="account-page__main-wrap  container">
    <div class="account-page__main  container-inner" style="width: 100%;">
      <div class="account-interaction">
        <div class="account-interaction__content" id="interaction-content">
          <div class="account-interaction__nav  interaction-nav-bar">
            <div class="interaction-nav-bar__head">
              <h3 class="interaction-nav-bar__title">Статус</h3>
            </div>
          </div>
          <div class="account-interaction__inner">
            <div class="account-interaction__inner-scroll custom-scrollbar">

              <div class="interaction-step">
                <div class="interaction-step__header">
                  <div class="interaction-step__header-row">
                    <h3 class="interaction-step__title">Загрузите билеты</h3><!---->
                  </div><!---->
                </div>
                <div class="interaction-step__content-wrap">
                  <div class="interaction-step__content">
                    <div class="interaction-step__content-inner">
                      <slot></slot>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="windowSizeMixin.width > 1023"
               class="account-interaction__chat  interaction-chat">
            <div class="interaction-chat__head">
              <h3 class="interaction-chat__title">Чат с Олегом</h3>
              <div class="interaction-chat__info _online">
                <span>Сейчас на сайте</span>
                <div class="interaction-chat__info-avatar">

                </div>
              </div>
            </div>
            <div class="interaction-chat__content">
            </div>

            <div class="interaction-toggle d-none d-md-flex">
              <button type="button"
                      class="interaction-toggle__btn"
                      @click.prevent="onClose"
              >
                <BaseSvg name="ico-gear-2"
                         width="1.5rem"
                         height="1.5rem"/>
                <span>Действия</span>
              </button>
              <button type="button"
                      class="interaction-toggle__btn _accent _chat _active"
              >
                <BaseSvg name="ico-msg"
                         width="1.7rem"
                         height="1.5rem"/>
                <span>Чат</span>
              </button>
            </div>
          </div>
          <div class="interaction-toggle d-none d-md-flex">
            <button type="button"
                    class="interaction-toggle__btn _active"

            >
              <BaseSvg name="ico-gear-2"
                       width="1.5rem"
                       height="1.5rem"/>
              <span>Действия</span>
            </button>
            <button type="button"
                    class="interaction-toggle__btn _accent _chat"
            >
              <BaseSvg name="ico-msg"
                       width="1.7rem"
                       height="1.5rem"/>
              <span>Чат</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import windowSizeMixin from "../mixins/windowSizeMixin"

  export default {
    mixins: [windowSizeMixin],
  }
</script>

<style lang="less">

</style>
